import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["zoneList", "delivererList", "instructions"]
  static values = { baseUrl: String, menuBaseUrl: String }

  connect() {
    this.mode = "deliverer"

    if (this.hasDelivererListTarget) {
      this.delivererSortable = Sortable.create(this.delivererListTarget, {
        animation: 150,
        handle: ".drag-handle"
      })
    }

    if (this.hasZoneListTarget) {
      this.zoneSortable = Sortable.create(this.zoneListTarget, {
        animation: 150,
        handle: ".drag-handle"
      })
    }
  }

  switchMode(event) {
    this.mode = event.currentTarget.dataset.mode
    if (this.hasInstructionsTarget) {
      this.instructionsTarget.textContent = this.mode === "zone"
        ? "Arrastrá las zonas para elegir el orden de impresión del PDF:"
        : "Arrastrá los repartidores para elegir el orden de impresión del PDF:"
    }
  }

  download(event) {
    event.preventDefault()
    this._openWithOrder(this.baseUrlValue)
  }

  downloadMenu(event) {
    event.preventDefault()
    this._openWithOrder(this.menuBaseUrlValue)
  }

  _openWithOrder(baseUrl) {
    const url = new URL(baseUrl, window.location.origin)

    if (this.mode === "zone" && this.hasZoneListTarget) {
      const items = this.zoneListTarget.querySelectorAll("[data-zone]")
      Array.from(items).forEach(item => url.searchParams.append("zone_order[]", item.dataset.zone))
    } else if (this.mode === "deliverer" && this.hasDelivererListTarget) {
      const items = this.delivererListTarget.querySelectorAll("[data-deliverer-id]")
      Array.from(items).forEach(item => url.searchParams.append("deliverer_order[]", item.dataset.delivererId))
    }

    window.open(url.toString(), "_blank")
  }
}
